"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .directive("keywordFilter", function () {
    return {
      restrict: "E",
      scope: {
        keyword: "=",
        help: "=?",
      },
      templateUrl: "/modules/Commom/core/views/keywordfilter.html",
      controller: function ($scope) {
        // $scope.help = angular.isDefined($scope.help) ? $scope.help : 'Digite uma palavra-chave';
      },
    };
  });
